import { render } from "./PasswordReset.vue?vue&type=template&id=28ee765e&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=28ee765e&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ee765e"]])

export default __exports__